import React, { useState } from "react";
import Advantage1 from "../assets/advantages/advantage-1.webp";
import Advantage2 from "../assets/advantages/advantage-2.webp";
import Advantage3 from "../assets/advantages/advantage-3.webp";
import Advantage4 from "../assets/advantages/advantage-4.webp";
import { BsCheck2 } from "react-icons/bs";
import languageStorage from "../lang/findLanguage";

export default function Advantages({ language }) {
  const [data] = useState([
    {
      id: 1,
      headerTitle: languageStorage() === "tr" ? language[0].sections[5].keys[0].k0001 : language[1].sections[5].keys[0].k0001,
      title: languageStorage() === "tr" ? language[0].sections[5].keys[1].k0002 : language[1].sections[5].keys[1].k0002,
      title2: "",
      img: Advantage1,
      text: [
        languageStorage() === "tr" ? language[0].sections[5].keys[2].k0003 : language[1].sections[5].keys[2].k0003,
        languageStorage() === "tr" ? language[0].sections[5].keys[3].k0004 : language[1].sections[5].keys[3].k0004,
      ],
      bottom: languageStorage() === "tr" ? language[0].sections[5].keys[4].k0005 : language[1].sections[5].keys[4].k0005,
    },
    {
      id: 2,
      headerTitle: languageStorage() === "tr" ? language[0].sections[5].keys[0].k0001 : language[1].sections[5].keys[0].k0001,
      title: languageStorage() === "tr" ? language[0].sections[5].keys[5].k0006 : language[1].sections[5].keys[5].k0006,
      title2: languageStorage() === "tr" ? language[0].sections[5].keys[6].k0007 : language[1].sections[5].keys[6].k0007,
      img: Advantage2,
      text: [
        languageStorage() === "tr" ? language[0].sections[5].keys[7].k0008 : language[1].sections[5].keys[7].k0008,
        languageStorage() === "tr" ? language[0].sections[5].keys[8].k0009 : language[1].sections[5].keys[8].k0009,
        languageStorage() === "tr" ? language[0].sections[5].keys[9].k0010 : language[1].sections[5].keys[9].k0010,
      ],
      bottom: languageStorage() === "tr" ? language[0].sections[5].keys[10].k0011 : language[1].sections[5].keys[10].k0011,
    },
    {
      id: 3,
      headerTitle: languageStorage() === "tr" ? language[0].sections[5].keys[0].k0001 : language[1].sections[5].keys[0].k0001,
      title: languageStorage() === "tr" ? language[0].sections[5].keys[11].k0012 : language[1].sections[5].keys[11].k0012,
      title2: "",
      img: Advantage3,
      text: [
        languageStorage() === "tr" ? language[0].sections[5].keys[12].k0013 : language[1].sections[5].keys[12].k0013,
        languageStorage() === "tr" ? language[0].sections[5].keys[13].k0014 : language[1].sections[5].keys[13].k0014,
      ],
      bottom: languageStorage() === "tr" ? language[0].sections[5].keys[14].k0015 : language[1].sections[5].keys[14].k0015,
    },
    {
      id: 4,
      headerTitle: languageStorage() === "tr" ? language[0].sections[5].keys[0].k0001 : language[1].sections[5].keys[0].k0001,
      title: languageStorage() === "tr" ? language[0].sections[5].keys[15].k0016 : language[1].sections[5].keys[15].k0016,
      title2: "",
      img: Advantage4,
      text: [
        languageStorage() === "tr" ? language[0].sections[5].keys[16].k0017 : language[1].sections[5].keys[16].k0017,
        languageStorage() === "tr" ? language[0].sections[5].keys[17].k0018 : language[1].sections[5].keys[17].k0018,
      ],
      bottom: languageStorage() === "tr" ? language[0].sections[5].keys[18].k0019 : language[1].sections[5].keys[18].k0019,
    },
  ]);
  return (
    <div className="advantages " id={languageStorage() === "tr" ? language[0].sections[11].keys[2].k0003 : language[1].sections[11].keys[2].k0003}>
      <div className="card-items">
        {data.map((item) => (
          <div className="card-item d-flex flex-column" key={item.id}>
            <div className="card-item-header d-flex align-items-center justify-content-between">
              <div className="card-item-title">
                <label>{item.headerTitle}</label>
                <p>
                  {item.title}
                  {item.title2 && (
                    <>
                      <br /> {item.title2}
                    </>
                  )}
                </p>
              </div>
              <img src={item.img} className="card-image img-fluid" height="90px" width="118px" alt={item.title} />
            </div>
            <div className="card-item-body">
              {item.text.map((subItem, index) => (
                <p className="card-item-body-text" key={index}>
                  <BsCheck2 size="20" color="#DF500E" />
                  <span>{subItem}</span>
                </p>
              ))}
            </div>
            <div className="card-item-footer">
              <p>{item.bottom}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="advantages-button d-flex align-items-center justify-content-center">
        <button
          onClick={() =>
            (window.location.href = `#${languageStorage() === "tr" ? language[0].sections[11].keys[5].k0006 : language[1].sections[11].keys[5].k0006}`)
          }
        >
          {languageStorage() === "tr" ? language[0].sections[5].keys[19].k0020 : language[1].sections[5].keys[19].k0020}
        </button>
      </div>
    </div>
  );
}
